"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayValidator = void 0;
const ramda_1 = require("ramda");
const validator_1 = require("./validator");
const utils_1 = require("./utils");
class ArrayValidator extends validator_1.CommonValidator {
    merge(props) {
        return new ArrayValidator({ ...this.props, ...props });
    }
    minItems(minItems) {
        return this.merge({ minItems });
    }
    maxItems(maxItems) {
        return this.merge({ maxItems });
    }
    uniqueItems(uniqueItems = true) {
        return this.merge({ uniqueItems });
    }
    items(validator) {
        return this.merge({ items: validator });
    }
    getPropsToLog() {
        return (0, ramda_1.dissoc)("items", super.getPropsToLog());
    }
    getAllPossibleInterpretations() {
        const { interpretations = [], items } = this.props;
        const out = interpretations.slice();
        if (items !== undefined) {
            out.push(...items.getAllPossibleInterpretations());
        }
        return out;
    }
    getAllPossibleTags() {
        const { tags = [], items } = this.props;
        const out = tags.slice();
        if (items !== undefined) {
            out.push(...items.getAllPossibleTags());
        }
        return out;
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [
                this.validateType,
                this.validateMinItems,
                this.validateMaxItems,
                this.validateUniqueItems,
                this.validateItems
            ]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (Array.isArray(ctx.value)) {
            return next();
        }
        ctx.addError({ type: "array" });
    };
    validateMinItems = async ({ rootCtx, ctx, next }) => {
        const minItems = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.minItems);
        if (minItems === undefined || ctx.value.length >= minItems) {
            return next();
        }
        ctx.addError({ minItems });
    };
    validateMaxItems = async ({ rootCtx, ctx, next }) => {
        const maxItems = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.maxItems);
        if (maxItems === undefined || ctx.value.length <= maxItems) {
            return next();
        }
        ctx.addError({ maxItems });
    };
    validateUniqueItems = async ({ rootCtx, ctx, next }) => {
        const uniqueItems = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.uniqueItems);
        if (uniqueItems !== true || isUnique(ctx.value)) {
            return next();
        }
        ctx.addError({ uniqueItems });
    };
    validateItems = async ({ rootCtx, ctx, next, options }) => {
        const { items } = this.props;
        if (items === undefined) {
            return next();
        }
        let value = ctx.value;
        for (let i = 0, l = value.length; i < l; i++) {
            const itemCtx = ctx.createChild(i);
            await items.entry({ rootCtx, ctx: itemCtx, options });
            if (itemCtx.value !== value[i]) {
                if (value === ctx.value) {
                    value = [...value];
                }
                value[i] = itemCtx.value;
            }
            ctx.mergeLogItems(itemCtx);
        }
        if (value !== ctx.value) {
            ctx.value = value;
        }
        return next();
    };
}
exports.ArrayValidator = ArrayValidator;
function isUnique(value) {
    return value.every((a, i) => value.findIndex(b => (0, ramda_1.equals)(a, b)) === i);
}
